import { useMemo } from 'react';

import { useNodesQuery } from 'hooks/queries/nodes/useNodesQuery';

import { useCluster } from '@cast/shared-cluster-context-data-access';

export const useHasFailedToDrainNodes = (): boolean => {
  const { cluster } = useCluster();

  const { nodes } = useNodesQuery({
    clusterId: cluster.id,
  });

  /* 
    TODO: use API filter to fetch only failed to drain nodes once the following ticket is unblocked:
    https://castai.atlassian.net/browse/UI-4700
  */
  const hasFailedToDrainNodes = useMemo(() => {
    return (nodes || []).some((node) => node.isFailedToDrain);
  }, [nodes]);

  return hasFailedToDrainNodes;
};
